<template>
  <div class="allcards">
    <md-card class="subCardFeed">

      <md-card-header>

        <!-- <div class="iconsCard">
          <md-icon v-if="chapter.media.video" class="md-primary iconCard">play_circle_outline</md-icon>
          <md-icon v-if="chapter.media.audio" class="md-primary iconCard">volume_up</md-icon>
        </div> -->

        <md-avatar @click="linkToProfile">
          <img :src="user.profileImg" alt="Avatar">
        </md-avatar>

        <router-link v-if="user.id" class="md-title author nostyle" :to="{ name: 'profile', params: { id: user.id }}">{{ user.fullName || user.name }}</router-link>
        <div v-else class="md-title author"><i>Nome</i></div>
        <div class="md-subhead"> {{ toDate(chapter.createdAt) || 'Data' }} </div>

      </md-card-header>

      <md-card-media v-if="chapter.media && chapter.media[0]" class="imageCard">
        <media style="padding: 0;" :url="chapter.media[0].url" />
      </md-card-media>

      <md-card-header-text>
        <div class="md-title titleCard">{{ chapter.title }}</div>
      </md-card-header-text>

      <md-card-content class="contentText" v-show="synopsis">{{ synopsis }}</md-card-content>

      <md-card-actions>
        <md-button :to="{ name: 'chapter', params: { id: chapter.id } }" :md-ripple="false" class="md-raised md-primary buttonReadMore">
          Ler Mais
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import dateMod from "@/assets/js/date";
import media from "@/components/content/chapter/slide/media";

export default {
  props: {
    chapter: {
      type: Object,
      validator: (chapter) => {
        // console.log(chapter);
        return chapter != null &&
               chapter.id != null &&
               chapter.author != null &&
               chapter.title != null &&
              //  chapter.media != null &&
               chapter.content != null &&
               chapter.position != null;
      }
    },
    profile: {
      type: Object,
      validator: (profile) => {
        return profile != null;
      }
    // },
    // place: {
    //   type: Object,
    //   validator: (place) => {
    //     return place != null;
    //   }
    }
  },
  components: {
    media
  },
  computed: {
    synopsis() {
      let index = this.chapter.content.indexOf('\n');
      return index == -1? this.chapter.content : this.chapter.content.slice(0, index);
    },
    user() {
      return this.profile || this.defaultProfile;
    }
  },
  data() {
    return {
      defaultProfile: {
        profileImg: require('@/assets/avatarDefault.png'),
        name: 'Nome'
      }
    }
  },
  methods: {
    linkToProfile() {
      return this.$router.push({ name: 'profile', params: { id: this.user.id }});
    },
    toDate(date) {
      return dateMod.toDate(new Date(date), "time");
    }
  },
};
</script>

<style scoped>
.subCardFeed{
  /* top: 55px; */
  width: 100%;
  /* height: 30vh; */
  margin: 4px;
  display: inline-block;
  vertical-align: top;
  overflow: hidden;
}

.titleCard{
  padding: 0.5em;
  margin: 5px;
  word-wrap: break-word;
  font-size: 20px;
  font-weight: 400;
}

.imageCard{
  height: 100%;
  /* padding: 1em; */
}

.image{
  max-height: 28vh;
  object-fit: cover;
}

.author {
  cursor: pointer;
}

a.nostyle:link {
  text-decoration: inherit;
  color: inherit;
}

a.nostyle:visited {
  text-decoration: inherit;
  color: inherit;
}

.buttonResume {
  width: 100%;
}

.contentText{
  word-break: break-word;
  padding-top: 0;
}

.iconsCard{
  margin: 10px;
  float: right;
}

.iconCard{
  margin: 0 5px;
}

@media (max-width: 451px) {

  .imageCard{
    height: 100%;
    padding: 0;
  }

}
</style>
